module.exports = __webpack_public_path__ + "static/img/exp_four.5fb61161.png";